// context/ProfileContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { IUser } from "../types/user";
import { IChatUserDetails, IContactDetailsTypes, IProfileDetailsTypes, profileDetails } from "../types/profile";
// import { IContact } from "../types/contacts";

interface ProfileContextType {
  profile: IUser;
  updateProfile: (data: Partial<IUser>) => void;

  // 🔥 ADICIONAR ESTADO PARA O PROFILE DA CONVERSA
  chatUserDetails: IContactDetailsTypes | null;
  setChatUserDetails: React.Dispatch<React.SetStateAction<IContactDetailsTypes | null>>;
}

export const ProfileContext = createContext<ProfileContextType | null>(null);

export const ProfileProvider = ({ children }: { children: React.ReactNode }) => {

  // ESTADO DO USUÁRIO LOGADO
  const [profile, setProfile] = useState<IUser>(() => {
    const saved = localStorage.getItem("authUser");
    return saved
      ? JSON.parse(saved)
      : {
        id: 0,
        name: "",
        email: "",
        enterprise: "",
        role: "",
        isActive: false,
        avatar: null,
      };
  });

  // 🔥 ESTADO DO USUÁRIO SELECIONADO NO CHAT (PANEL DIREITO)
  const [chatUserDetails, setChatUserDetails] =
    useState<IContactDetailsTypes | null>(null);

  const updateProfile = (data: Partial<IUser>) => {
    setProfile((prev) => ({ ...prev, ...data }));
  };

  useEffect(() => {
    localStorage.setItem("authUser", JSON.stringify(profile));
  }, [profile]);

  return (
    <ProfileContext.Provider
      value={{
        profile,
        updateProfile,

        // 🔥 EXPOSE PARA O PANEL
        chatUserDetails,
        setChatUserDetails,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfileContext must be inside ProfileProvider");
  return ctx;
};
